<template>
    <div>
        <div class="card mb-2" v-for="(field, elemKey) in fields" :key="field.id">
            <div :class="{'card-header': true, 'text-danger': errors[field.id]}">
                <div class="row">
                    <div class="col-md-6 col-12 form-inline">
                        <span class="mr-2">{{ field.label || ''}}: <span class="text-muted" title="This is the field's type.">{{ field.type }}</span></span>
                    </div>
                    <div class="col-md-6 col-12">
                        <div class="float-right">
                            <input type="text" :value="field.order" class="form-control form-control-sm d-inline-block" placeholder="Field Order" style="width: 65px" title="Field Order" @input="setFieldOrder(field.id, $event)" />
                            <button class="btn btn-sm btn-light" @click="toggleField(field.id)" :title="(field.show_body ? 'Hide' : 'Show') + ' Field Options'">
                                 <i :class="'fa fa-caret-' + (field.show_body !== true ? 'down' : 'up')"></i>
                            </button>
                            <button class="btn btn-sm btn-light" @click="deleteField(field, elemKey)" title="Delete Field" :disabled="deleting_field != null && deleting_field == field.id">
                                <i class="fa fa-spinner fa-spin" v-if="deleting_field != null && deleting_field == field.id"></i>
                                <i class="fa fa-trash text-danger" v-else></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div :class="{'card-body': true, 'd-none': (!field.show_body || field.show_body == false)}"> -->
            <div :class="{'card-body': true, 'd-none': (field.show_body == false)}">

                <div class="form-group row mb-2" v-if="errors[field.id]">
                    <div class="col-sm-10 offset-sm-1">
                        <div class="alert alert-danger">
                            <strong>Validation Errors:</strong>
                            <ul>
                                <li v-for="err in errors[field.id]">{{ err }}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Only Render This Field If:</label>
                    <div class="col-sm-8 pt-2">
                        <b-form-select v-model="field.parent_field_id" :options="conditionalFieldOptions(field.id)" size="sm">
                            <template v-slot:first>
                                <option :value="null">-- Select A Parent Field. Leave Blank to Always Show this Field --</option>
                            </template>
                        </b-form-select>
                        <b-form-select v-if="field.parent_field_id" v-model="field.parent_field_value" :options="conditionalFieldValues(field.parent_field_id)" size="sm" class="mt-2">
                            <template v-slot:first>
                                <option :value="null">-- Select A Value --</option>
                            </template>
                        </b-form-select>
                    </div>
                </div>

                <template v-if="field.type != 'Paragraph' && field.type != 'Heading'">
                    <div class="form-group row">
                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Required:</label>
                        <div class="col-sm-8 pt-2">
                            <b-form-checkbox v-model="field.is_required" :value="1" :unchecked-value="0" plain></b-form-checkbox>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">
                            Add to List <i class="fa fa-question-circle" title="If checked, MeritEHS will add this as a column to the main list of records"></i>:
                        </label>
                        <div class="col-sm-8 pt-2">
                            <b-form-checkbox v-model="field.add_to_list" :value="1" :unchecked-value="0" plain></b-form-checkbox>
                        </div>
                    </div>
                </template>

                <div class="form-group row" v-if="field.type != 'Paragraph'">
                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">
                        Label:
                    </label>
                    <div class="col-sm-8">
                        <b-form-input v-model="field.label" placeholder="Enter a Field Label" size="sm" class="mr-2" />
                    </div>
                </div>

                <div class="form-group row">
                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Help Text:</label>
                    <div class="col-sm-8">
                        <b-form-input v-model="field.help_text" placeholder="Enter Some Help Text for the Field" size="sm" />
                    </div>
                </div>

                <div class="form-group row" v-if="('placeholder' in field)">
                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Placeholder:</label>
                    <div class="col-sm-8">
                        <b-form-input v-model="field.placeholder" placeholder="Enter a Placeholder Label" size="sm" />
                    </div>
                </div>

                <template v-if="field.type == 'Dropdown'">
                    <div class="form-group row">
                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Allow Multiple:</label>
                        <div class="col-sm-8 pt-2">
                            <b-form-checkbox v-model="field.allow_multiple" :value="true" :unchecked-value="false" plain>Allow Multiple Selections</b-form-checkbox>
                        </div>
                    </div>
                </template>

                <template v-if="field.type == 'Dropdown'">
                    <div class="form-group row">
                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">
                            Options:<br>
                            <a href="javascript:void(0)" @click="$set(field.options, `field-${new Date().getTime()}`)">Add Option <i class="fa fa-plus-circle"></i></a>
                        </label>
                        <div class="col-sm-8">
                            <div v-for="(option, key) in field.options" class="form-inline mb-2">
                                <b-form-input v-model="field.options[key]" placeholder="Enter Option" size="sm" />

                                <a href="jvascript:void(0)" class="text-danger ml-2" v-on:click="deleteOption(field.id, key)"><i class="fa fa-trash"></i></a>
                            </div>
                        </div>
                    </div>
                </template>

                <template v-if="field.type == 'Radio' || field.type == 'Checkbox'">
                    <div class="form-group row">
                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Vertical Display:</label>
                        <div class="col-sm-8 pt-2">
                            <b-form-checkbox v-model="field.display_vertical" :value="true" :unchecked-value="false" plain>Display the options vertically. Default is inline.</b-form-checkbox>
                        </div>
                    </div>
                    <!-- <div class="form-group row">
                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Enable "Other":</label>
                        <div class="col-sm-8 pt-2">
                            <b-form-checkbox v-model="field.enable_other" :value="true" :unchecked-value="false" plain>Let users to enter an unlisted option</b-form-checkbox>
                        </div>
                    </div> -->
                    <div class="form-group row">
                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">
                            Options:<br>
                            <a href="javascript:void(0)" @click="$set(field.options, `field-${new Date().getTime()}`)">Add Option <i class="fa fa-plus-circle"></i></a>
                        </label>
                        <div class="col-sm-8">
                            <div v-for="(option, key) in field.options" class="form-inline">
                                <!-- <span class="mr-2">Option {{ key + 1 }}:</span> -->
                                <b-form-input v-model="field.options[key]" placeholder="Enter Option" size="sm" />
                                <button type="button" class="btn btn-link text-danger"  v-on:click="deleteOption(field.id, key)"><i class="fa fa-trash"></i></button>
                            </div>
                        </div>
                    </div>
                </template>

                <div class="form-group row" v-if="field.type == 'File'">
                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Allowed File Types:</label>
                    <div class="col-sm-8">
                        <div class="text-info mb-1">-- Leave Unchecked to Allow All File Types --</div>
                        <b-form-checkbox-group v-model="field.file_types" stacked plain :options="fileTypeOptions"></b-form-checkbox-group>
                    </div>
                </div>

                <div class="form-group row" v-if="field.type == 'Textarea'">
                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Rich Text:</label>
                    <div class="col-sm-8">
                        <b-form-checkbox v-model="field.enable_rich_text" :value="true" :unchecked-value="false" plain>
                            Enable Rich Text
                        </b-form-checkbox>
                        <p>This will activate the rich text editor that allows users to bold, highlight, list, and edit text.</p>
                    </div>
                </div>

                <template v-if="field.type == 'Number'">
                    <div class="form-group row"">
                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Min:</label>
                        <div class="col-sm-8">
                            <b-form-input v-model="field.min" placeholder="Enter Min Value" size="sm"></b-form-input>
                        </div>
                    </div>
                    <div class="form-group row"">
                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Max:</label>
                        <div class="col-sm-8">
                            <b-form-input v-model="field.max" placeholder="Enter Max Value" size="sm"></b-form-input>
                        </div>
                    </div>
                    <div class="form-group row"">
                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Step:</label>
                        <div class="col-sm-8">
                            <b-form-input v-model="field.step" placeholder="Enter Step Value" size="sm"></b-form-input>
                        </div>
                    </div>
                </template>

                <!-- <template v-if="field.type == 'Employee' || field.type == 'Equipment' || field.type == 'Jobsite' || field.type == 'User'">
                    <div class="form-group row">
                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right"></label>
                        <div class="col-sm-8 pt-2">
                            <b-form-checkbox v-model="field.allow_multiple" :value="true" :unchecked-value="false" plain>Allow Multiple Selections</b-form-checkbox>
                        </div>
                    </div>
                </template> -->

                <template v-if="field.type == 'Paragraph'">
                    <div class="form-group row"">
                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Block Text:</label>
                        <div class="col-sm-8">
                            <b-form-textarea v-model="field.text" placeholder="Enter Block Text" rows="5"></b-form-textarea>
                        </div>
                    </div>
                    <div class="form-group row"">
                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Background Color:</label>
                        <div class="col-sm-8">
                            <b-form-radio-group plain v-model="field.color">
                                <b-form-radio :value="null">
                                    <i class="fa fa-square-o"></i> -- None --
                                </b-form-radio><br/>
                                <b-form-radio value="primary">
                                    <i class="fa fa-square text-primary"></i> Primary
                                </b-form-radio><br/>
                                <b-form-radio value="secondary">
                                    <i class="fa fa-square text-secondary"></i> Secondary
                                </b-form-radio><br/>
                                <b-form-radio value="info">
                                    <i class="fa fa-square text-info"></i> Info
                                </b-form-radio><br/>
                                <b-form-radio value="warning">
                                    <i class="fa fa-square text-warning"></i> Warning
                                </b-form-radio><br/>
                                <b-form-radio value="success">
                                    <i class="fa fa-square text-success"></i> Success
                                </b-form-radio><br/>
                                <b-form-radio value="danger">
                                    <i class="fa fa-square text-danger"></i> Danger
                                </b-form-radio><br/>
                                <b-form-radio value="light">
                                    <i class="fa fa-square text-light"></i> Light
                                </b-form-radio><br/>
                                <b-form-radio value="dark">
                                    <i class="fa fa-square text-dark"></i> Dark
                                </b-form-radio><br/>
                            </b-form-radio-group>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            sectionId: {
                required: true,
            },

            startingFields: {
                type: Array,
                required: true,
            },

            enableAddToList: {
                type: Boolean,
                default: false,

            },
        },

        data() {
            return {
                //Setup
                fields: [],
                errors: {},
                deleting_field: null,

                file_types: {
                    'csv': 'CSV',
                    'doc': 'DOC',
                    'docx': 'DOCX',
                    'gif': 'GIF',
                    'pdf': 'PDF',
                    'png': 'PNG',
                    'jpeg': 'JPEG',
                    'jpg': 'JPG',
                    'tiff': 'TIFF',
                    'xls': 'XLS',
                    'xlsx': 'XLSX',
                },
            }
        },

        watch: {
            fields: {
                deep: true,
                handler(){
                    //Emit the fields
                    this.$emit('fieldsChanged', this.fields);
                }
            }
        },

        computed: {
            parentFields(){
                //Build based on the list of sections and their fields
                var parentFields = [];

                //Loop through the sections
                for(var j = 0; j < this.fields.length; j++)
                {
                    //Check the type
                    if(this.fields[j].type != 'Dropdown' && this.fields[j].type != 'Radio' && this.fields[j].type != 'Checkbox')
                    {
                        continue;
                    }

                    //Add the Option
                    parentFields.push({value: this.fields[j].id, text: (this.fields[j].label ? this.fields[j].label : this.fields[j].id)});
                }

                //SEnd it
                return parentFields;
            },

            fileTypeOptions(){
                //Setup
                var options = [];

                //Setup
                const keys = Object.keys(this.file_types);

                //Loop through and build lists
                for(var i = 0; i < keys.length; i++)
                {
                    //Push onto options
                    options.push({value: keys[i], text: this.file_types[keys[i]]});
                }

                //Send ti
                return options;
            },
        },

        methods: {
            conditionalFieldOptions(fieldId){
                //Clone it
                var options = JSON.parse(JSON.stringify(this.parentFields));

                //Unset the ID from the Conditional Fields
                for(var i = 0; i < options.length; i++)
                {
                    //Check the ID
                    if(fieldId == options[i].value)
                    {
                        //Remove the Option
                        options.splice(i, 1);
                    }
                }

                //Send ti
                return options;
            },

            conditionalFieldValues(parentFieldId){
                //Setup
                var options = [];

                //Loop through the sections
                for(var j = 0; j < this.fields.length; j++)
                {
                    //Check the ID
                    if(parentFieldId == this.fields[j].id)
                    {
                        //Add All the Options
                        options = this.fields[j].options;
                    }
                }

                //Send it
                return options;
            },

            deleteOption(fieldId, optionIndex){
                //Loop through all
                for(var j = 0; j < this.fields.length; j++)
                {
                    //Check the if
                    if(fieldId == this.fields[j].id)
                    {
                        //Replace it to force a redraw
                        var field = this.fields[j];

                        //IF the fields core_field_value is the option, set it to null
                        if(field.core_field_value == optionIndex)
                        {
                            field.core_field_value = null;
                        }

                        //Remove the option
                        delete field.options[optionIndex];

                        //Set
                        this.fields.splice(j, 1, field);

                        //Set it
                        return;
                    }
                }
            },

            setFieldOrder(fieldId, event){
                //SEtup
                var newOrder = parseInt(event.target.value);

                //Check the value?
                if(newOrder < 0 || newOrder >= this.fields.length)
                {
                    //Stop here
                    this.$toastr.error('Invalid Order#, the order must be between 0 and ' + this.fields.length);

                    //Return
                    return;
                }

                //Build a list of available order#
                var orderNumbers = [];

                //Loop and build
                for(var t = 0; t < this.fields.length; t++)
                {
                    //Exclude the newOrder
                    if(t != newOrder)
                    {
                        orderNumbers.push(t);
                    }
                }

                //Loop through the sections
                for(var j = 0; j < this.fields.length; j++)
                {
                    //Check the ID
                    if(fieldId == this.fields[j].id)
                    {
                        //Set the Order
                        this.fields[j].order = newOrder;
                    }
                    else
                    {
                        //Pop the first value off the available order numbers
                        this.fields[j].order = orderNumbers[0];

                        //Remove the order number
                        orderNumbers.splice(0, 1);
                    }
                }

                //Reorder ALL section fields
                this.fields.sort((a, b) => (a.order > b.order) ? 1 : -1);
            },

            toggleField(fieldId){
                //Loop through all
                for(var j = 0; j < this.fields.length; j++)
                {
                    //Check the if
                    if(fieldId == this.fields[j].id)
                    {
                        //Replace it to force a redraw
                        var field = this.fields[j];

                        //SEtter
                        field.show_body = field.show_body === true || field.show_body === undefined ? false : true;

                        //Set
                        this.fields.splice(j, 1, field);

                        //Set it
                        return;
                    }
                }
            },

            setErrors(errors){
                //Set it
                this.errors = errors;
            },

            deleteField(field, elemKey){
                //Check for an ID
                if(!field.id || field.id === '')
                {
                    //Splice it
                    this.fields.splice(elemKey, 1);

                    return;
                }

                //Ajax Delete
                this.deleting_field = field.id;

                //Set it
                this.$http.post('/custom-fields/delete/'+field.id)
                    .then(response => {
                        //Alert the user?
                        this.$toastr.success('Custom Field Deleted');

                        //Remove it
                        this.fields.splice(elemKey, 1);
                    })
                    .catch(error => {
                        //Debug
                        console.log(error);

                        //Alert the User
                        this.$toastr.error(error.response);
                    })
                    .then(response => {
                        //SHow loading
                        this.deleting_field = null;
                    });
            },
        },

        mounted() {
            //Setup
            this.fields = this.startingFields;
        },
    }
</script>